import { Component } from '@angular/core';

@Component({
  selector: 'app-icons-sprite',
  templateUrl: './combined.svg',
  styles: [
    `
      :host {
        width: 0;
        height: 0;
        visibility: hidden;
        position: absolute;
        overflow: hidden;
        z-index: -1;
      }
    `
  ],
  standalone: false
})
export class IconsSpriteComponent {}
